import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";

export default function LoginPage() {
  const { instance } = useMsal();

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>PO Manager</h1>
        <p>Sign in with your Microsoft 365 account to access your SharePoint purchase orders.</p>
        <button
          className="ms-btn"
          onClick={() => instance.loginPopup(loginRequest)}
        >
          <svg className="ms-logo" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="9" height="9" fill="#F25022"/>
            <rect x="11" y="1" width="9" height="9" fill="#7FBA00"/>
            <rect x="1" y="11" width="9" height="9" fill="#00A4EF"/>
            <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
          </svg>
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
}
